import { cn } from "../cn";

export interface ChartEmptyStateProps {
  readonly className?: string;
  readonly height?: number;
}

/**
 * Placeholder shown by every chart primitive when its period holds no data.
 * Lives on its own rather than inside one of the charts so the breakdown
 * components do not have to import a shared bit from a sibling chart.
 */
export function ChartEmptyState({
  className,
  height = 160,
}: ChartEmptyStateProps) {
  return (
    <div
      className={cn(
        "grid place-items-center rounded-lg border border-dashed border-border/70 text-sm text-muted-foreground",
        className,
      )}
      style={{ height }}
    >
      Geen gegevens in deze periode.
    </div>
  );
}
